import { Grid } from "@material-ui/core";
import clsx from "clsx";
import { useAtomValue } from "jotai";
import { LearningPathMenu } from "../../learning-path/components/path-learning-menu/learning-path-menu.component";
import type { MxQuickWin } from "../../models/gameplan";
import { ProgressBar } from "../progress-bar";
import { currentGamePlanIndexAtom, progressAtom } from "./atoms";
import { ItemDisplay } from "./item-display.component";
import { GamePlanItemType, useGamePlanPath } from "./use-game-plan";
import { useStyles } from "./wizard.styles";

type Props = {
  setMxQuickWin: (quickWin: MxQuickWin) => void;
};

export const Wizard = ({ setMxQuickWin }: Props) => {
  const classes = useStyles();
  const {
    gamePlans,
    flattenGamePlans,
    isGamePlanCompleted,
    isLoading,
    isLearningPathStarted,
    isLearningPathFinished,
  } = useGamePlanPath();
  const progress = useAtomValue(progressAtom);
  const currentGamePlanIndex = useAtomValue(currentGamePlanIndexAtom);
  const gamePlan = flattenGamePlans?.at(currentGamePlanIndex);

  const showProgressBar = [
    GamePlanItemType.LESSON,
    GamePlanItemType.WORKOUT,
    GamePlanItemType.DISCOVER,
  ].includes(gamePlan?.type);

  return (
    <>
      <Grid className={classes.panelWrapper}>
        <Grid item className={classes.leftPanel}>
          <LearningPathMenu
            focusedItem={currentGamePlanIndex}
            items={gamePlans}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item className={classes.rightPanel}>
          <Grid className={classes.wizardContainer}>
            <Grid
              item
              xs={12}
              className={clsx({
                [classes.emptyProgressContainer]: !showProgressBar,
                [classes.progressContainer]: showProgressBar,
              })}
            >
              {showProgressBar && <ProgressBar value={progress} />}
            </Grid>
            <ItemDisplay
              gamePlan={gamePlan}
              setMxQuickWin={setMxQuickWin}
              isGamePlanCompleted={isGamePlanCompleted}
              isLearningPathStarted={isLearningPathStarted}
              isLearningPathFinished={isLearningPathFinished}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
